import { PermissionSets } from '../types';
import { mkPath, mkUrl, mkUrlNav, obscureUrls } from './_';
export const systemUrls = {
    analytics: mkUrlNav(mkPath('system'), [...PermissionSets.system.analytics], {
        nav: { label: 'Analytics', icon: 'bi-graph-up', section: 'Home' },
    }),
    communities: mkUrlNav(mkPath('system', 'communities'), [...PermissionSets.system.districts], {
        nav: { label: 'Communities & Organizations', icon: 'bi-buildings', section: 'Management' },
    }),
    communitiesManage: mkUrl(mkPath('system', 'communities', '$id'), [...PermissionSets.system.districts]),
    partners: mkUrlNav(mkPath('system', 'partners'), [...PermissionSets.system.districts], {
        nav: { label: 'Partners', icon: 'bi-award', section: 'Management' },
    }),
    users: mkUrlNav(mkPath('system', 'users'), [...PermissionSets.system.users], {
        nav: { label: 'Users', icon: 'bi-people', section: 'Management' },
    }),
    usersDetail: mkUrl(mkPath('system', 'users', '$id'), [...PermissionSets.system.users]),
    moderation: mkUrlNav(mkPath('system', 'moderation'), [...PermissionSets.system.moderation], {
        nav: { label: 'Moderation', icon: 'bi-shield-check', section: 'Management' },
    }),
    settings: mkUrlNav(mkPath('system', 'settings'), [...PermissionSets.system.settings], {
        nav: { label: 'Settings', icon: 'bi-gear-wide-connected', section: 'Management' },
    }),
    exploreCategories: mkUrlNav(mkPath('system', 'explore-categories'), [...PermissionSets.system.districts], {
        nav: { label: 'Explore Categories', icon: 'bi-funnel', section: 'Management' },
    }),
    nrhpSync: mkUrlNav(mkPath('system', 'nrhp-sync'), [...PermissionSets.system.settings], {
        nav: { label: 'NRHP Sync', icon: 'bi-cloud-arrow-down', section: 'Management' },
    }),
    scheduledJobs: mkUrlNav(mkPath('system', 'scheduled-jobs'), [...PermissionSets.system.settings], {
        nav: { label: 'Scheduled Jobs', icon: 'bi-alarm', section: 'Management' },
    }),
    blobCleanup: mkUrlNav(mkPath('system', 'blob-cleanup'), [...PermissionSets.system.settings], {
        nav: { label: 'Blob Cleanup', icon: 'bi-trash3', section: 'Management' },
    }),
    policies: mkUrlNav(mkPath('system', 'policies'), [...PermissionSets.system.policies], {
        nav: { label: 'Policies', icon: 'bi-file-earmark-text', section: 'Management' },
    }),
    staticContent: mkUrlNav(mkPath('system', 'static-content'), [...PermissionSets.system.settings], {
        nav: { label: 'Pages', icon: 'bi-file-earmark-richtext', section: 'Static Content' },
    }),
    staticContentNav: mkUrlNav(mkPath('system', 'static-content', 'nav'), [...PermissionSets.system.settings], {
        'nav': { 'label': 'Navigation', 'icon': 'bi-file-earmark-richtext', 'section': 'Static Content' },
    }),
    appPages: mkUrlNav(mkPath('system', 'app-pages'), [...PermissionSets.system.settings], {
        nav: { label: 'App Page SEO', icon: 'bi-search', section: 'Static Content' },
    }),
    rootFiles: mkUrlNav(mkPath('system', 'root-files'), [...PermissionSets.system.settings], {
        nav: { label: 'Root Files', icon: 'bi-file-earmark-arrow-up', section: 'Static Content' },
    }),
    assets: mkUrlNav(mkPath('system', 'assets'), [...PermissionSets.system.settings], {
        nav: { label: 'Media Library', icon: 'bi-images', section: 'Static Content' },
    }),
    activityLog: mkUrlNav(mkPath('system', 'activity-log'), [...PermissionSets.system.logs], {
        nav: { label: 'Activity', icon: 'bi-clock-history', section: 'Logs' },
    }),
    errorLog: mkUrlNav(mkPath('system', 'error-log'), [...PermissionSets.system.logs], {
        nav: { label: 'Errors', icon: 'bi-exclamation-triangle', section: 'Logs' },
    }),
};
// Paths, permissions and nav only: what the user menu needs to find a system admin's landing page
export const systemUrlsArray = obscureUrls(systemUrls);
